module.exports = __webpack_public_path__ + "static/mirror-of-life-trapping-mtg_clb-82148f4894f44fce19fe975652efd5c2.webp";